import axios from 'axios'
import { useEffect, useState } from 'react'
import { LAYOUT_DATA_AUTH, LAYOUT_DATA_URL } from '../api/settings'
import i18n from '../i18n'
import { LocalStorageCache } from '../services/LocalStorageCache'
import bottomMenuCs from './data/cs/bottomMenu.json'
import footerMenuCs from './data/cs/footerMenu.json'
import headerMenuCs from './data/cs/headerMenu.json'
import socialIconLinksCs from './data/cs/socialIconLinks.json'
import bottomMenuEn from './data/en/bottomMenu.json'
import footerMenuEn from './data/en/footerMenu.json'
import headerMenuEn from './data/en/headerMenu.json'
import socialIconLinksEn from './data/en/socialIconLinks.json'

const STORAGE_KEY = 'layoutData'
const FILES = ['bottomMenu', 'footerMenu', 'headerMenu', 'socialIconLinks']

interface iLayoutData {
  bottomMenu: { path: string, text: string }[],
  footerMenu: { name: string, links: { path: string, text: string }[] }[],
  headerMenu: { path: string, text: string }[],
  socialIconLinks: { name: string, links: { path: string, iconClassName: string, ariaLabel: string }[] }
}

let PROMISE_ALL_LAYOUT_DATA: any

interface iLayoutDataPack {
  key: string,
  data: any
}

var basicAuth = LAYOUT_DATA_AUTH ? ('Basic ' + btoa(LAYOUT_DATA_AUTH)) : ''

export const useLayoutData = () => {

  const lang = i18n.language
  const isCs = i18n.language === 'cs'

  const defData: iLayoutData = {
    bottomMenu: isCs ? bottomMenuCs : bottomMenuEn,
    footerMenu: isCs ? footerMenuCs : footerMenuEn,
    headerMenu: isCs ? headerMenuCs : headerMenuEn,
    socialIconLinks: isCs ? socialIconLinksCs : socialIconLinksEn,
  }

  const [layoutData, setLayoutData] = useState<iLayoutData>()

  useEffect(() => {
    if (lang) {

      const savedData = LocalStorageCache.getItem(STORAGE_KEY + lang, undefined)

      if (savedData) {
        setLayoutData(savedData)
      } else {
        const loadData = {} as iLayoutData
        if (!PROMISE_ALL_LAYOUT_DATA) {

          const req = FILES.map(file =>
            axios.get(`${LAYOUT_DATA_URL}/wp-json/iq/v1/config/${file}/${lang}`,
              basicAuth ? { headers: { 'Authorization': basicAuth } } : undefined
            )
              .then(res => ({ key: file, data: res.data }))
              .catch(err => {
                console.log('err load layout data', file, lang, err)
              })
          )
          PROMISE_ALL_LAYOUT_DATA = Promise.all(req)
        }
        PROMISE_ALL_LAYOUT_DATA
          .then((results: iLayoutDataPack[]) => {
            results.forEach(res => {
              if (res) {
                // TODO test na delku dat a jestli jsou v JSON???
                loadData[res.key as keyof iLayoutData] = res.data
              }
            })
            if (Object.keys(loadData).length === FILES.length) {
              LocalStorageCache.setItem(STORAGE_KEY + lang, loadData)
              setLayoutData(loadData)
            } else {
              setLayoutData(defData)
            }
          })
          .catch((e: any) => {
            setLayoutData(defData)
          })
          .finally(() => {
            PROMISE_ALL_LAYOUT_DATA = undefined
          })
      }
    }

  }, [lang]) // eslint-disable-line react-hooks/exhaustive-deps

  return layoutData
}
